import { setCursorPositionAction } from 'actions/emoji/emojiAction'
import { AsyncThunkAction } from 'actions/types'
import { newLine } from 'common-constants/text'

export const SET_MESSENGER_INPUT_VALUE_ACTION =
  'SET_MESSENGER_INPUT_VALUE_ACTION'

export interface SetMessengerInputAction {
  type: typeof SET_MESSENGER_INPUT_VALUE_ACTION
  contentInput: string
}

export const setMessengerInputAction = (contentInput: string) => ({
  type: SET_MESSENGER_INPUT_VALUE_ACTION,
  contentInput,
})

export const sendAppFeedbackMessage =
  (): AsyncThunkAction => (dispatch, getState) => {
    const {
      systemReducer: {
        query: { ['message_header']: messageHeader },
      },
    } = getState()
    if (messageHeader) {
      const messageWithNewLine = messageHeader + newLine
      const cursorPosition = messageWithNewLine.length
      dispatch(setMessengerInputAction(messageWithNewLine))
      dispatch(setCursorPositionAction(cursorPosition, cursorPosition))
    }
  }

export type MessengerTextActionTypes = SetMessengerInputAction
